import { render } from "./lMoney.vue?vue&type=template&id=581c1a0a&ts=true"
import script from "./lMoney.vue?vue&type=script&lang=ts"
export * from "./lMoney.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__